import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import AppRoutes from "./routing/app-routes";
import Layout from "./routing/Layout";
import { useAgencyInfo } from "./context/agency";
import { useEffect } from "react";

function App() {
  const [agency] = useAgencyInfo();
  const routes = AppRoutes();

  console.log(agency?.customCode, "customCodecustomCodecustomCodecustomCodecustomCode");

  // Set favicon dynamically when agency data is loaded
  useEffect(() => {
    const Meta_logo = agency?.theme_id?.theme_data?.general?.Meta_logo;
    if (Meta_logo) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = Meta_logo;
    }
  }, [agency]);

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.path) {
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              route?.layout === "blank" ? (
                route.element
              ) : (
                <Layout>{route.element}</Layout>
              )
            }
          />
        );
      }

      return null;
    });
  };

  const pageTitle =
    agency?.theme_id?.theme_data?.general?.home_m_title || "Loading...";
  const pageDescription =
    agency?.theme_id?.theme_data?.general?.home_m_description ||
    "Discover and list local businesses with ease. Users can submit their business profiles for admin approval, and once verified, get featured on our public directory to boost visibility and reach.";

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        {/* update the favicon */}
        <link
          rel="icon"
          href={
            agency?.theme_id?.theme_data?.general?.Meta_logo ||
            "https://snapshotstore.fra1.digitaloceanspaces.com/Untitled%20design%20%287%29-83731"
          }
        />
        {agency?.customCode?.headerCode && (
          <script type="text/javascript">
            {`document.head.insertAdjacentHTML('beforeend', \`${agency.customCode.headerCode}\`);`}
          </script>
        )}
      </Helmet>

      {agency?.customCode?.bodyCode && (
        <div
          dangerouslySetInnerHTML={{ __html: agency.customCode.bodyCode }}
          style={{ display: "contents" }}
        />
      )}

      <Routes>{getRoutes(routes)}</Routes>

      <Toaster />
    </div>
  );
}

export default App;
